module.exports = __webpack_public_path__ + "static/media/num_of_noncoding_driver_per_publication_2022_latest.3165dd13.png";